import { Pagination } from 'components/Pagination'
import { TestimonialModal } from 'components/TestimonialModal'
import { TestimonialCard } from 'components/Testimonials'
import { useBlogPostsQuery } from 'hooks/useBlogPostsQuery'
import { useUrl } from 'hooks/useUrl'
import { ComponentType, useState } from 'react'
import { Col, Container, Row } from 'reactstrap'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

const Wrapper = styled.div`
  ${up('sm')} {
    padding: 0 20px 20px 20px;
  }
`

const Inner = styled.div`
  background: ${({ theme }) => theme.colors.lilyWhite};

  ${up('sm')} {
    border-radius: 10px;
  }
`

const Intro = styled.div`
  padding: 72px 0 56px 0;

  ${up('sm')} {
    padding: 107px 0 80px 0;
  }
`

const Suptitle = styled.h6`
  color: #0078c9;
  font-size: 14px;
  font-weight: bold;
  line-height: 18px;
  text-transform: uppercase;
  margin-bottom: 12px;
  text-align: center;

  ${up('sm')} {
    display: none;
  }
`

const Title = styled.h1`
  margin-bottom: 8px;
  font-size: 23px;
  font-weight: bold;
  line-height: 38px;
  text-align: center;

  ${up('sm')} {
    font-size: 26px;
    font-weight: bold;
    line-height: 37px;
  }
`

const Subtitle = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 27px;
  text-align: center;
  color: ${({ theme }) => theme.colors.regalBlue};

  ${up('sm')} {
    font-size: 16px;
    line-height: 29px;
  }
`

const Item = styled.div`
  padding: 8px 0;

  ${up('sm')} {
    height: 100%;
    display: flex;
    padding: 15px 0;
  }
`

const PaginationWrapper = styled.div`
  padding: 50px 0;
`

export const Listing: ComponentType = () => {
  const [testimonialId, setTestimonialId] = useState<null>()
  const { query } = useUrl()

  const { data, loading } = useBlogPostsQuery({
    variables: {
      query: { limit: 9, page: query.page, filter: 'tag:testimonios' },
    },
  })

  return (
    <Wrapper>
      <Inner>
        <Container>
          <Row className="justify-content-center">
            <Col lg={6}>
              <Intro>
                <Suptitle>Yucatán Premier</Suptitle>
                <Title>Experiencia Premier en Bienes Raíces</Title>
                <Subtitle>
                  Sabemos que adquirir o rentar una propiedad es algo muy importante; por ello brindamos un servicio
                  dedicado. Nuestra misión es ayudar a quienes están buscando ese espacio ideal, a encontrarlo; y a
                  quienes quieren vender o rentar su propiedad, hacerlo; siempre con la calidez que nos distingue a los
                  yucatecos.
                </Subtitle>
              </Intro>
            </Col>
          </Row>
          <Row>
            {data?.blogPosts.posts.map((post: any, index: number, arr: any[]) => {
              const prev = arr[index - 1]
              const next = arr[index + 1]

              return (
                <Col key={post.id} sm={6} lg={4}>
                  <Item>
                    <TestimonialCard testimonial={post} onClick={() => setTestimonialId(post.id)} />
                    {testimonialId === post.id && (
                      <TestimonialModal
                        testimonial={post}
                        onPrev={prev ? () => setTestimonialId(prev.id) : undefined}
                        onNext={next ? () => setTestimonialId(next.id) : undefined}
                        onToggle={() => setTestimonialId(null)}
                        open
                      />
                    )}
                  </Item>
                </Col>
              )
            })}
          </Row>
          <Row>
            <Col>
              {data?.blogPosts.meta.pagination.pages > 1 && (
                <PaginationWrapper>
                  <Pagination
                    total={data.blogPosts.meta.pagination.total}
                    limit={data.blogPosts.meta.pagination.limit}
                    page={data.blogPosts.meta.pagination.page}
                    loading={loading}
                  />
                </PaginationWrapper>
              )}
            </Col>
          </Row>
        </Container>
      </Inner>
    </Wrapper>
  )
}
